import { ReservoirIcon } from '../icons'

export default {
  id: 'reservoirs',
  title: {
    en: 'reservoirs',
    ar: 'الخزانات'
  },
  Icon: ReservoirIcon,
  description: {
    en: `<p>The word <strong>“reservoir”</strong> comes from the French word <strong>“réservoir”</strong>, meaning a <strong>“tank”</strong>. Reservoirs are enlarged natural or artificial lakes, ponds, or structures built to store water.</p><p>Jordan’s reservoirs have a total capacity of approximately 600,000 cubic meters.</p>`,
    ar: ``
  },
  entries: [
    {
      id: 'res01',
      title: {
        en: 'Wadi Al-Arab',
        ar: 'وادي العرب'
      },
      capacity: '1,700',
      suppliedBy: {
        en: ['Manndah 2 Well', 'Wadi Al Arab PS2'],
        ar: ['محطة ضخ وادي العرب 2', 'بئر مندح 2']
      },
      position: { x: 376, y: 230 }
    },
    {
      id: 'res02',
      title: {
        en: 'Zabda',
        ar: 'زبدة'
      },
      capacity: '100,000',
      suppliedBy: {
        en: 'Wadi Al Arab PS3',
        ar: 'محطة ضخ وادي العرب 3'
      },
      position: { x: 430, y: 275 }
    },
    {
      id: 'res03',
      title: { en: 'Hofa el Mazar', ar: 'حوفا المزار' },
      capacity: '17,000',
      suppliedBy: {
        en: ['Um Lulu PS', ' Zabda PS'],
        ar: ['محطة ضخ ام اللول', 'محطة ضخ زبدة']
      },
      position: { x: 445, y: 305 }
    },
    {
      id: 'res04',
      title: {
        en: 'Samad',
        ar: 'صمد'
      },
      capacity: '25,000',
      suppliedBy: {
        en: 'Hufa PS',
        ar: 'محطة ضخ حوفا'
      },
      position: { x: 445, y: 335 }
    },
    {
      id: 'res05',
      title: {
        en: 'Um Lulu',
        ar: 'ام اللولو'
      },
      capacity: '6,000',
      suppliedBy: {
        en: 'Zaatari PS',
        ar: 'محطة ضخ الزعتري'
      },
      position: { x: 565.0, y: 318.0 }
    },
    {
      id: 'res06',
      title: {
        en: 'Bwaida',
        ar: 'بويضة'
      },
      capacity: '1,000',
      suppliedBy: {
        en: 'Um Lulu PS',
        ar: 'محطة ضخ ام اللولو'
      },
      position: { x: 555.0, y: 348.0 }
    },
    {
      id: 'res07',
      title: {
        en: 'Zaatari',
        ar: 'الزعتري'
      },
      capacity: '10,000',
      suppliedBy: {
        en: [
          'Zaatari well field',
          'Corador wellfield',
          'Aqeb wellfield',
          'economic wellfield'
        ],
        ar: [
          'آبار الزعتري،',
          'آبار الكوردور',
          'آبار المنطقة الاقتصادية',
          'آبار العاقب'
        ]
      },
      position: { x: 650.0, y: 361.0 }
    },
    {
      id: 'res08',
      title: {
        en: 'Khaw',
        ar: 'خو'
      },
      capacity: '16,000',
      suppliedBy: {
        en: [
          'Corodour Wellfield',
          'Al Hallabat PS',
          'Al Azraq PS',
          'Abu Alanda reservoir',
          'Al Hzam (Marqab) reservoir'
        ],
        ar: [
          'خزان الحزام (مرقب)',
          'محطة ضخ الحلابات',
          'آبار الكوردور،',
          'خزان أبو علندا',
          'محطة ضخ الأزرق'
        ]
      },
      position: { x: 610.0, y: 430.0 }
    },
    {
      id: 'res09',
      title: {
        en: 'Dabouq',
        ar: 'دابوق'
      },
      capacity: '250,000',
      suppliedBy: {
        en: ['Zai WTP', 'Disi'],
        ar: ['محطة معالجة وضخ زي', 'آبار الديسي']
      },
      position: { x: 480.0, y: 487.0 }
    },
    {
      id: 'res10',
      title: {
        en: 'Abu Alanda 1',
        ar: 'ابو علندا 1'
      },
      capacity: '50,000',
      suppliedBy: {
        en: 'Disi',
        ar: 'آبار الديسي'
      },
      position: { x: 522.0, y: 520.0 }
    },
    {
      id: 'res11',
      title: {
        en: 'Abu Alanda 2',
        ar: 'ابو علندا 2'
      },
      capacity: '100,000',
      suppliedBy: {
        en: 'Abu Alanda 1 Disi reservoir	',
        ar: 'خزان أبو علندا 1'
      },
      position: { x: 550, y: 520 }
    },
    {
      id: 'res12',
      title: {
        en: 'Azraq',
        ar: 'الأزرق'
      },
      capacity: '12,000',
      suppliedBy: {
        en: 'Azraq wellfield',
        ar: 'آبار الأزرق'
      },
      position: { x: 840.0, y: 572.0 }
    },
    {
      id: 'res13',
      title: {
        en: 'Al Lajoon',
        ar: 'اللجون'
      },
      capacity: '4,000',
      suppliedBy: {
        en: ['Al Lajoon wellfied Part 2', 'Qatranah PS'],
        ar: ['محطة ضخ القطرانة', 'آبار اللجون']
      },
      position: { x: 435.0, y: 797.0 }
    },
    {
      id: 'res14',
      title: {
        en: 'Ghwair',
        ar: 'الغوير'
      },
      capacity: '4,500',
      suppliedBy: {
        en: ['Al Soltani PS', 'Al Lajoon PS', 'Ghwair well field'],
        ar: ['محطة ضخ السلطان', 'محطة ضخ اللجون', 'آبار الغوير']
      },
      position: { x: 408.0, y: 814.0 }
    },
    {
      id: 'res15',
      title: {
        en: 'Hasa 1',
        ar: 'الحسا 1'
      },
      capacity: '500',
      suppliedBy: {
        en: 'Hasa well field',
        ar: 'آبار الحسا'
      },
      position: { x: 410.0, y: 992.0 }
    },
    {
      id: 'res16',
      title: {
        en: 'Hasa 2',
        ar: 'الحسا 2'
      },
      capacity: '500',
      suppliedBy: {
        en: 'Hasa 1 Res.',
        ar: 'خزان الحسا 1'
      },
      position: { x: 395.0, y: 1020.0 }
    },
    {
      id: 'res17',
      title: {
        en: 'Hasa 3',
        ar: 'الحسا 3'
      },
      capacity: '500',
      suppliedBy: {
        en: 'Hasa 2 Res.',
        ar: 'خزان الحسا 2'
      },
      position: { x: 380.0, y: 992.0 }
    },
    {
      id: 'res18',
      title: {
        en: 'Tahoneh New',
        ar: 'الطاحونة الجديد'
      },
      capacity: '4,500',
      suppliedBy: {
        en: 'Al Tahooneh well field	',
        ar: 'آبار الطاحونة'
      },
      position: { x: 383.0, y: 1171.0 }
    }
  ]
}
